$state-icon-size: 56px;

.icon {
    font-size: $state-icon-size;
    width: $state-icon-size;
    height: $state-icon-size;
}
